// import React, { useState } from 'react';
// import { Home, Zap, ShoppingCart, User, Heart, Star, Filter, ChevronLeft } from 'lucide-react';

// // --- Data Mockup ---
// const mockProducts = [
//     {
//         id: 1,
//         title: "ES-BOX12, 5.12kWh, 51.2V, 100Ah",
//         price: "1232460.71",
//         rating: 5, // Full stars in mock image
//         imageUrl: "https://placehold.co/300x300/e0f2fe/0c4a6e/png?text=Battery+A",
//     },
//     {
//         id: 2,
//         title: "ES-BOX12 PLUS, 10.24kWh, 51.2V, 200Ah",
//         price: "2243654.07",
//         rating: 4.5, // Half star in mock image
//         imageUrl: "https://placehold.co/300x300/eff6ff/1e3a8a/png?text=Battery+B",
//     },
//     {
//         id: 3,
//         title: "Inverter Package, 5kVA, MPPT",
//         price: "650000.00",
//         rating: 4,
//         imageUrl: "https://placehold.co/300x300/f0f9ff/075985/png?text=Inverter+C",
//     },
//     {
//         id: 4,
//         title: "Solar Panel, 450W Monocrystalline",
//         price: "125999.00",
//         rating: 5,
//         imageUrl: "https://placehold.co/300x300/f0f9ff/075985/png?text=Panel+D",
//     },
// ];

// // --- Sub Components ---

// /**
//  * Reusable component for a single product card in the catalog.
//  */
// const ProductCard = ({ product ,setActiveScreen}) => {
//     // Helper function to format currency as seen in the image (Nigerian Naira NGN)
//     const formatCurrency = (amount) => {
//         const parts = amount.toString().split('.');
//         const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
//         const decimalPart = parts.length > 1 ? '.' + parts[1] : '.00';
//         return `${integerPart}${decimalPart} NGN`;
//     };

//     const displayRating = Math.min(5, Math.max(0, product.rating));

//     return (
//         <div className="w-full bg-white rounded-lg overflow-hidden border border-gray-100 shadow-sm cursor-pointer">
//             {/* Image & Heart Icon */}
//             <div className="relative aspect-[1/1.1] bg-white flex items-center justify-center p-2">
//                 <img 
//                     src={product.imageUrl} 
//                     alt={product.title} 
//                     className="w-full h-full object-contain rounded-lg"
//                     onError={(e) => { e.target.onerror = null; e.target.src="https://placehold.co/300x330/e0f2fe/0c4a6e?text=Product"; }}
//                 />
//                 <button 
//                     className="absolute top-2 right-2 p-1 bg-white rounded-full text-gray-500 hover:text-red-500 transition shadow-sm"
//                     aria-label="Add to favorites"
//                     onClick={(e) => { e.stopPropagation(); console.log(`Favorite toggled for ${product.id}`); }}
//                 >
//                     <Heart className="w-4 h-4" />
//                 </button>
//             </div>

//             {/* Product Details */}
//             <div className="p-2 pt-1 pb-3">
//                 {/* Title */}
//                 <p className="text-[11px] font-semibold text-gray-900 h-6 overflow-hidden leading-tight mb-1">
//                     {product.title}
//                 </p>
                
//                 {/* Price */}
//                 <p className="text-sm font-extrabold text-gray-800 mb-1">
//                     {formatCurrency(product.price)}
//                 </p>

//                 {/* Rating Stars */}
//                 <div className="flex items-center text-xs space-x-[1px] mb-3">
//                     {Array(5).fill(0).map((_, i) => (
//                         <Star 
//                             key={i}
//                             className={`w-3 h-3 transition-colors`}
//                             fill={displayRating > i ? '#f59e0b' : '#d1d5db'} // Yellow or Gray
//                             stroke={displayRating > i ? '#f59e0b' : '#d1d5db'}
//                         />
//                     ))}
//                 </div>

//                 {/* Buttons (Gradient Primary and White Secondary) */}
//                 <div className="flex flex-col space-y-2">
//                     <button 
//                         className="w-full py-2 text-sm text-white font-semibold rounded-lg transition"
//                         style={{ backgroundImage: 'linear-gradient(to right, #4C72EF, #2D58E9)', boxShadow: '0 4px 6px rgba(45, 88, 233, 0.4)' }}
//                         onClick={(e) => { e.stopPropagation(); console.log(`Buy ${product.title}`); }}
//                     >
//                         Buy Now
//                     </button>
//                     <button 
//                         className="w-full py-2 text-sm bg-white text-blue-600 font-semibold border border-blue-600 rounded-lg hover:bg-blue-50 transition"
//                         onClick={(e) => { e.stopPropagation(); console.log(`View ${product.title}`);
//                             setActiveScreen('marketplaceProductView')
//                          }}
//                     >
//                         View more
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// };


// // --- Main Screen Component ---

// const MarketplaceScreen = ({setActiveScreen}) => {
//     const [activeTab, setActiveTab] = useState('Item 1');
//     const tabs = ['Item 1', 'Item 2', 'Item 3', 'Item 4', 'Item 5', 'Item 6'];

//     return (
//         <div className="min-h-screen flex justify-center bg-gray-100 font-sans">
//             <style>{`.hide-scrollbar::-webkit-scrollbar { display: none; } .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }`}</style>

//             <div className="w-full max-w-md bg-white shadow-2xl overflow-hidden flex flex-col h-screen">
                
//                 {/* Fixed Top Area (Title and Back button) */}
//                 <header className="px-4 py-3 flex items-center justify-center bg-white sticky top-0 z-20">
//                     {/* Placeholder for back button and battery/time icons */}
//                     <div className="absolute left-4 top-4">
//                         <ChevronLeft className="w-6 h-6 text-gray-800" />
//                     </div>
//                     <h1 className="text-lg font-bold text-gray-800">Marketplace</h1>
//                 </header>

//                 {/* Floating "Marketplace" text and Filter icon */}
//                 <div className="px-4 pb-3 pt-1 flex items-center justify-between bg-white sticky top-[56px] z-10 border-b border-gray-100">
//                     <h2 className="text-xl font-bold text-gray-900">Marketplace</h2>
//                     <button 
//                         className="p-2 text-gray-600 hover:bg-gray-100 rounded-lg transition duration-150"
//                         aria-label="Filter products"
//                         onClick={() => console.log('Filters opened')}
//                     >
//                         <Filter className="w-6 h-6" />
//                     </button>
//                 </div>


//                 {/* Category Tabs (Horizontal Scrollable) */}
//                 <div className="px-4 pb-3 bg-white sticky top-[110px] z-10">
//                     <div className="overflow-x-auto flex space-x-2 hide-scrollbar">
//                         {tabs.map(tab => (
//                             <button
//                                 key={tab}
//                                 className={`px-4 py-2 text-sm font-semibold rounded-full transition duration-200 whitespace-nowrap ${
//                                     activeTab === tab
//                                         ? 'bg-blue-600 text-white shadow-md'
//                                         : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
//                                 }`}
//                                 onClick={() => setActiveTab(tab)}
//                             >
//                                 {tab}
//                             </button>
//                         ))}
//                     </div>
//                 </div>

//                 {/* Product Catalog Grid */}
//                 <main className="flex-1 overflow-y-auto p-4 pb-20"> {/* pb-20 for bottom padding above navbar */}
//                     <div className="grid grid-cols-2 gap-3">
//                         {mockProducts.map(product => (
//                             <ProductCard key={product.id} product={product} setActiveScreen={setActiveScreen}/>
//                         ))}
//                         {/* Repeat cards for scrolling effect */}
//                         {mockProducts.map((product, index) => (
//                             <ProductCard key={product.id + '_r' + index} product={{...product, id: product.id + 100 + index}} />
//                         ))}
//                     </div>
//                 </main>

              
//             </div>
//         </div>
//     );
// };

// export default MarketplaceScreen;



// import React, { useState, useEffect, useCallback } from 'react';
// import { Home, Zap, ShoppingCart, User, Heart, Star, Filter, ChevronLeft, Loader2, AlertTriangle } from 'lucide-react';

// // --- API Configuration ---
// const API_URL = 'https://psh-admin.zolute.xyz/api/product-categories';
// // Use the placeholder token. Replace <token> with your actual Bearer token.

// // --- Utility Functions ---

// /**
//  * Implements exponential backoff retry mechanism for API calls.
//  * @param {Function} apiCall - The async function to execute.
//  * @param {number} retries - Maximum number of retries.
//  * @param {number} delay - Initial delay in milliseconds.
//  */
// const exponentialBackoffFetch = async (apiCall, retries = 3, delay = 1000) => {
//     for (let i = 0; i < retries; i++) {
//         try {
//             return await apiCall();
//         } catch (error) {
//             if (i === retries - 1) {
//                 throw error; // Throw error on last attempt
//             }
//             await new Promise(resolve => setTimeout(resolve, delay * Math.pow(2, i)));
//         }
//     }
// };

// /**
//  * Helper function to format currency (Nigerian Naira NGN)
//  * @param {string | number} amount 
//  */
// const formatCurrency = (amount) => {
//     // Ensure amount is treated as a string to handle large numbers and precision
//     const amountStr = String(amount); 
//     const parts = amountStr.split('.');
//     const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
//     // Pad with .00 if no decimal part, or limit to two decimal places
//     const decimalPart = parts.length > 1 ? '.' + parts[1].padEnd(2, '0').substring(0, 2) : '.00';
//     return `${integerPart}${decimalPart} NGN`;
// };


// // --- Sub Components ---

// /**
//  * Reusable component for a single product card in the catalog.
//  */
// const ProductCard = ({ product , setActiveScreen}) => {
    
//     // Ensure rating is between 0 and 5
//     const displayRating = Math.min(5, Math.max(0, product.rating)); 

//     return (
//         <div 
//             className="w-full bg-white rounded-lg overflow-hidden border border-gray-100 shadow-sm cursor-pointer"
//             onClick={() => {
//                 // Navigate to a product detail screen
//                 setActiveScreen('marketplaceProductView'); 
//                 console.log(`Navigating to detail view for ${product.id}`);
//             }}
//         >
//             {/* Image & Heart Icon */}
//             <div className="relative aspect-[1/1.1] bg-white flex items-center justify-center p-2">
//                 <img 
//                     src={product.imageUrl || `https://placehold.co/300x330/e0f2fe/0c4a6e?text=${encodeURIComponent(product.title.substring(0, 10))}`}
//                     alt={product.title} 
//                     className="w-full h-full object-contain rounded-lg"
//                     onError={(e) => { 
//                         e.target.onerror = null; 
//                         e.target.src=`https://placehold.co/300x330/e0f2fe/0c4a6e?text=${encodeURIComponent(product.title.substring(0, 10))}`; 
//                     }}
//                 />
//                 <button 
//                     className="absolute top-2 right-2 p-1 bg-white rounded-full text-gray-500 hover:text-red-500 transition shadow-sm"
//                     aria-label="Add to favorites"
//                     onClick={(e) => { e.stopPropagation(); console.log(`Favorite toggled for ${product.id}`); }}
//                 >
//                     <Heart className="w-4 h-4" />
//                 </button>
//             </div>

//             {/* Product Details */}
//             <div className="p-2 pt-1 pb-3">
//                 {/* Title */}
//                 <p className="text-[11px] font-semibold text-gray-900 h-6 overflow-hidden leading-tight mb-1">
//                     {product.title}
//                 </p>
                
//                 {/* Price */}
//                 <p className="text-sm font-extrabold text-gray-800 mb-1">
//                     {formatCurrency(product.price)}
//                 </p>

//                 {/* Rating Stars */}
//                 <div className="flex items-center text-xs space-x-[1px] mb-3">
//                     {Array(5).fill(0).map((_, i) => (
//                         <Star 
//                             key={i}
//                             className={`w-3 h-3 transition-colors`}
//                             fill={displayRating > i ? '#f59e0b' : '#d1d5db'} // Yellow or Gray
//                             stroke={displayRating > i ? '#f59e0b' : '#d1d5db'}
//                         />
//                     ))}
//                     <span className="text-gray-500 text-[10px] ml-1">({displayRating.toFixed(1)})</span>
//                 </div>

//                 {/* Buttons (Gradient Primary and White Secondary) */}
//                 <div className="flex flex-col space-y-2">
//                     <button 
//                         className="w-full py-2 text-sm text-white font-semibold rounded-lg transition"
//                         style={{ backgroundImage: 'linear-gradient(to right, #4C72EF, #2D58E9)', boxShadow: '0 4px 6px rgba(45, 88, 233, 0.4)' }}
//                         onClick={(e) => { e.stopPropagation(); console.log(`Buy ${product.title}`); }}
//                     >
//                         Buy Now
//                     </button>
//                     <button 
//                         className="w-full py-2 text-sm bg-white text-blue-600 font-semibold border border-blue-600 rounded-lg hover:bg-blue-50 transition"
//                         onClick={(e) => { e.stopPropagation(); 
//                             setActiveScreen('marketplaceProductView');
//                         }}
//                     >
//                         View more
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// };


// // --- Main Screen Component ---

// const MarketplaceScreen = ({ setActiveScreen,authToken}) => {
//     const [activeTab, setActiveTab] = useState('Item 1');
//     const [products, setProducts] = useState([]);
//     const [isLoading, setIsLoading] = useState(true);
//     const [error, setError] = useState(null);

//     const tabs = ['Item 1', 'Item 2', 'Item 3', 'Item 4', 'Item 5', 'Item 6'];

//     const fetchProducts = useCallback(async () => {
//         setIsLoading(true);
//         setError(null);
        
//         const apiCall = async () => {
//             const response = await fetch(API_URL, {
//                 method: 'GET',
//                 headers: {
//                     'Content-Type': 'application/json',
//                     // MANDATORY: Add the Authorization header for Bearer Token
//                     'Authorization': `Bearer ${authToken}` 
//                 },
//             });

//             if (!response.ok) {
//                 const errorBody = await response.text();
//                 // Check specifically for 404 (Not Found)
//                 if (response.status === 404) {
//                     throw new Error(`API Endpoint Not Found (404). Check the URL path on the server: ${API_URL}`);
//                 }
//                 // Check for 401/403 (Unauthorized/Forbidden)
//                 if (response.status === 401 || response.status === 403) {
//                     throw new Error(`Authentication Failed (Status: ${response.status}). Check if the Bearer Token is valid.`);
//                 }
//                 // Throw general HTTP error
//                 throw new Error(`HTTP error! Status: ${response.status}. Detail: ${errorBody.substring(0, 100)}...`);
//             }

//             return response.json();
//         };

//         const fallbackMockProducts = [
//             { id: 1, title: "ES-BOX12, 5.12kWh, 51.2V, 100Ah", price: "1232460.71", rating: 5, imageUrl: "https://placehold.co/300x300/e0f2fe/0c4a6e/png?text=Battery+A" },
//             { id: 2, title: "ES-BOX12 PLUS, 10.24kWh, 51.2V, 200Ah", price: "2243654.07", rating: 4.5, imageUrl: "https://placehold.co/300x300/eff6ff/1e3a8a/png?text=Battery+B" },
//             { id: 3, title: "Inverter Package, 5kVA, MPPT", price: "650000.00", rating: 4, imageUrl: "https://placehold.co/300x300/f0f9ff/075985/png?text=Inverter+C" },
//             { id: 4, title: "Solar Panel, 450W Monocrystalline", price: "125999.00", rating: 5, imageUrl: "https://placehold.co/300x300/f0f9ff/075985/png?text=Panel+D" },
//         ];


//         try {
//             const data = await exponentialBackoffFetch(apiCall);
            
//             // Assuming the API returns a list directly or within a 'results' field
//             if (Array.isArray(data)) {
//                 setProducts(data);
//             } else if (data && Array.isArray(data.results)) {
//                 setProducts(data.results);
//             } else {
//                  console.warn("API returned unexpected data format. Falling back to mock data.");
//                  setProducts(fallbackMockProducts);
//             }
//         } catch (err) {
//             console.error('Failed to fetch products:', err);
            
//             // Set the specific error message to be displayed
//             setError(err.message);
            
//             // Use mock data as a fallback to show the UI structure
//             setProducts(fallbackMockProducts);
//         } finally {
//             setIsLoading(false);
//         }
//     }, []);

//     // Effect to trigger data fetching on mount
//     useEffect(() => {
//         fetchProducts();
//     }, [fetchProducts]);
    
//     // --- Render Logic for Content ---
//     const renderContent = () => {
//         if (isLoading) {
//             return (
//                 <div className="flex flex-col items-center justify-center p-8 text-gray-500">
//                     <Loader2 className="w-8 h-8 animate-spin text-blue-600 mb-3" />
//                     <p className="text-sm font-medium">Loading products...</p>
//                     <p className="text-xs text-center mt-1">Fetching data from remote server...</p>
//                 </div>
//             );
//         }

//         if (error) {
//             return (
//                 <div className="bg-red-50 border-l-4 border-red-500 text-red-700 p-4 mx-4 my-4 rounded-lg shadow-inner">
//                     <div className="flex items-center">
//                         <AlertTriangle className="w-5 h-5 mr-3" />
//                         <p className="font-bold">Data Fetch Error</p>
//                     </div>
//                     <p className="text-sm mt-1">{error}</p>
//                     <p className="text-xs mt-2 italic">Displaying fallback product data.</p>
//                 </div>
//             );
//         }

//         if (products.length === 0) {
//             return (
//                 <div className="text-center p-8 text-gray-500">
//                     <Zap className="w-8 h-8 mx-auto mb-3" />
//                     <p className="text-sm font-medium">No products found.</p>
//                 </div>
//             );
//         }

//         return (
//             <div className="grid grid-cols-2 gap-3">
//                 {products.map(product => (
//                     <ProductCard 
//                         key={product.id} 
//                         product={product} 
//                         setActiveScreen={setActiveScreen}
//                     />
//                 ))}
//             </div>
//         );
//     };


//     return (
//         <div className="min-h-screen flex justify-center bg-gray-100 font-sans">
//             <style>{`.hide-scrollbar::-webkit-scrollbar { display: none; } .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }`}</style>

//             <div className="w-full max-w-md bg-white shadow-2xl overflow-hidden flex flex-col h-screen">
                
//                 {/* Fixed Top Area (Title and Back button) */}
//                 <header className="px-4 py-3 flex items-center justify-center bg-white sticky top-0 z-20">
//                     {/* Placeholder for back button and battery/time icons */}
//                     <div className="absolute left-4 top-4">
//                         <ChevronLeft className="w-6 h-6 text-gray-800" />
//                     </div>
//                     <h1 className="text-lg font-bold text-gray-800">Marketplace</h1>
//                 </header>

//                 {/* Floating "Marketplace" text and Filter icon */}
//                 <div className="px-4 pb-3 pt-1 flex items-center justify-between bg-white sticky top-[56px] z-10 border-b border-gray-100">
//                     <h2 className="text-xl font-bold text-gray-900">Marketplace</h2>
//                     <button 
//                         className="p-2 text-gray-600 hover:bg-gray-100 rounded-lg transition duration-150"
//                         aria-label="Filter products"
//                         onClick={() => console.log('Filters opened')}
//                     >
//                         <Filter className="w-6 h-6" />
//                     </button>
//                 </div>


//                 {/* Category Tabs (Horizontal Scrollable) */}
//                 <div className="px-4 pb-3 bg-white sticky top-[110px] z-10">
//                     <div className="overflow-x-auto flex space-x-2 hide-scrollbar">
//                         {tabs.map(tab => (
//                             <button
//                                 key={tab}
//                                 className={`px-4 py-2 text-sm font-semibold rounded-full transition duration-200 whitespace-nowrap ${
//                                     activeTab === tab
//                                         ? 'bg-blue-600 text-white shadow-md'
//                                         : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
//                                 }`}
//                                 onClick={() => setActiveTab(tab)}
//                             >
//                                 {tab}
//                             </button>
//                         ))}
//                     </div>
//                 </div>

//                 {/* Product Catalog Grid */}
//                 {/* Removed pb-20 since there is no navbar */}
//                 <main className="flex-1 overflow-y-auto p-4"> 
//                     {renderContent()}
//                 </main>
//             </div>
//         </div>
//     );
// };

// export default MarketplaceScreen;


import React, { useState, useEffect, useCallback } from 'react';
import { Home, Zap, ShoppingCart, User, Heart, Star, Filter, ChevronLeft, Loader2, AlertTriangle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../config/api';

// --- API Configuration ---
const API_URL = `${API_BASE_URL}/product-categories`;
// Use the placeholder token. Replace <token> with your actual Bearer token.

// --- Utility Functions ---

/**
 * Implements exponential backoff retry mechanism for API calls.
 * @param {Function} apiCall - The async function to execute.
 * @param {number} retries - Maximum number of retries.
 * @param {number} delay - Initial delay in milliseconds.
 */
const exponentialBackoffFetch = async (apiCall, retries = 3, delay = 1000) => {
    for (let i = 0; i < retries; i++) {
        try {
            return await apiCall();
        } catch (error) {
            if (i === retries - 1) {
                throw error; // Throw error on last attempt
            }
            await new Promise(resolve => setTimeout(resolve, delay * Math.pow(2, i)));
        }
    }
};

/**
 * Helper function to format currency (Nigerian Naira NGN)
 * @param {string | number} amount 
 */
const formatCurrency = (amount) => {
    // Ensure amount is treated as a string to handle large numbers and precision
    const amountStr = String(amount);
    const parts = amountStr.split('.');
    const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    // Pad with .00 if no decimal part, or limit to two decimal places
    const decimalPart = parts.length > 1 ? '.' + parts[1].padEnd(2, '0').substring(0, 2) : '.00';
    return `${integerPart}${decimalPart} NGN`;
};


// --- Sub Components ---

/**
 * Reusable component for a single product card in the catalog.
 */
const ProductCard = ({ product , setActiveScreen}) => {
    const navigate= useNavigate()
    // Ensure rating is between 0 and 5
    const displayRating = Math.min(5, Math.max(0, product.rating));




    


    return (
        <div 
            className="w-full bg-white rounded-lg overflow-hidden border border-gray-100 shadow-sm cursor-pointer"
            onClick={() =>  setActiveScreen('marketplaceProductView', { productId: product.id })}
        >
            {/* Image & Heart Icon */}
            <div className="relative aspect-[1/1.1] bg-white flex items-center justify-center px-2 pt-1">
                <img 
                    src={product.images && product.images.length > 0 ? product.images[0].url : ''}
                    alt={product.name} 
                    className="w-full h-32 object-cover rounded-lg"
                    onError={(e) => { 
                        e.target.onerror = null; 
                        // e.target.src=`https://placehold.co/300x330/e0f2fe/0c4a6e?text=${encodeURIComponent(product.title.substring(0, 10))}`; 
                    }}
                />
                <button 
                    className="absolute top-2 right-2 p-1 bg-white rounded-full text-gray-500 hover:text-red-500 transition shadow-sm"
                    aria-label="Add to favorites"
                    onClick={(e) => { e.stopPropagation(); console.log(`Favorite toggled for ${product.id}`); }}
                >
                    <Heart className="w-4 h-4" />
                </button>
            </div>

            {/* Product Details */}
            <div className="p-2 pb-3">
                {/* Title */}
                <p className="text-[11px] font-semibold text-gray-900 h-6 overflow-hidden leading-tight mb-1">
                    {product.name}
                </p>
                
                {/* Price */}
                <p className="text-sm font-extrabold text-gray-800 mb-1">
                    {formatCurrency(product.price)}
                </p>

                {/* Rating Stars */}
                <div className="flex items-center text-xs space-x-[1px] mb-3">
                    {Array(5).fill(0).map((_, i) => (
                        <Star 
                            key={i}
                            className={`w-3 h-3 transition-colors`}
                            fill={displayRating > i ? '#f59e0b' : '#d1d5db'} // Yellow or Gray
                            stroke={displayRating > i ? '#f59e0b' : '#d1d5db'}
                        />
                    ))}
                    <span className="text-gray-500 text-[10px] ml-1">({displayRating.toFixed(1)})</span>
                </div>

                {/* Buttons (Gradient Primary and White Secondary) */}
                <div className="flex flex-col space-y-2">
                    <button 
                        className="w-full py-2 text-sm text-white font-semibold rounded-lg transition"
                        style={{ backgroundImage: 'linear-gradient(to right, #4C72EF, #2D58E9)', boxShadow: '0 4px 6px rgba(45, 88, 233, 0.4)' }}
                        onClick={(e) => { e.stopPropagation(); console.log(`Buy ${product.id}`);    setActiveScreen('marketplaceProductView', { productId: product.id })}}
                    >
                        Buy Now
                    </button>
                    <button 
                        className="w-full py-2 text-sm bg-white text-blue-600 font-semibold border border-blue-600 rounded-lg hover:bg-blue-50 transition"
                        onClick={(e) => { e.stopPropagation(); 
                        setActiveScreen('marketplaceProductView', { productId: product.id })
                        }}
                    >
                        View more
                    </button>
                </div>
            </div>
        </div>
    );
};


// --- Main Screen Component ---

// const MarketplaceScreen = ({ setActiveScreen,authToken}) => {
//     // NEW: State to hold the fetched category objects
//     const [categories, setCategories] = useState([]); 
//     // Initialize activeTab to null or empty string, will be set after fetch
//     const [activeTab, setActiveTab] = useState(''); 
//     const [products, setProducts] = useState([]);
//     const [isLoading, setIsLoading] = useState(true);
//     const [error, setError] = useState(null);

//     // Removed the hardcoded 'tabs' array

//     const fetchProducts = useCallback(async () => {
//         setIsLoading(true);
//         setError(null);
        
//         const apiCall = async () => {
//             const response = await fetch(API_URL, {
//                 method: 'GET',
//                 headers: {
//                     'Content-Type': 'application/json',
//                     // MANDATORY: Add the Authorization header for Bearer Token
//                     'Authorization': `Bearer ${authToken}` 
//                 },
//             });

//             if (!response.ok) {
//                 const errorBody = await response.text();
//                 // Check specifically for 404 (Not Found)
//                 if (response.status === 404) {
//                     throw new Error(`API Endpoint Not Found (404). Check the URL path on the server: ${API_URL}`);
//                 }
//                 // Check for 401/403 (Unauthorized/Forbidden)
//                 if (response.status === 401 || response.status === 403) {
//                     throw new Error(`Authentication Failed (Status: ${response.status}). Check if the Bearer Token is valid.`);
//                 }
//                 // Throw general HTTP error
//                 throw new Error(`HTTP error! Status: ${response.status}. Detail: ${errorBody.substring(0, 100)}...`);
//             }

//             return response.json();
//         };

//         const fallbackMockProducts = [
//             { id: 1, title: "ES-BOX12, 5.12kWh, 51.2V, 100Ah", price: "1232460.71", rating: 5, imageUrl: "https://placehold.co/300x300/e0f2fe/0c4a6e/png?text=Battery+A" },
//             { id: 2, title: "ES-BOX12 PLUS, 10.24kWh, 51.2V, 200Ah", price: "2243654.07", rating: 4.5, imageUrl: "https://placehold.co/300x300/eff6ff/1e3a8a/png?text=Battery+B" },
//             { id: 3, title: "Inverter Package, 5kVA, MPPT", price: "650000.00", rating: 4, imageUrl: "https://placehold.co/300x300/f0f9ff/075985/png?text=Inverter+C" },
//             { id: 4, title: "Solar Panel, 450W Monocrystalline", price: "125999.00", rating: 5, imageUrl: "https://placehold.co/300x300/f0f9ff/075985/png?text=Panel+D" },
//         ];
        
//         // Mock categories for error fallback
//         const fallbackMockCategories = [
//              { id: 'mock1', name: 'Fallback A' },
//              { id: 'mock2', name: 'Fallback B' },
//              { id: 'mock3', name: 'Fallback C' }
//         ];


//         try {
//             const data = await exponentialBackoffFetch(apiCall);
            
//             // CORRECT: Check for the nested 'data.categories' field
//             const fetchedCategories = data?.data?.categories || [];
            
//             setCategories(fetchedCategories);
            
//             // Set the first fetched category as the active tab
//             if (fetchedCategories.length > 0) {
//                  setActiveTab(fetchedCategories[0].name);
//             }

//             // The categories API does not return products, so we set the mock products here
//             setProducts(fetchedCategories);
            
//         } catch (err) {
//             console.error('Failed to fetch categories:', err);
            
//             // Set the specific error message to be displayed
//             setError(err.message);
            
//             // Use mock data as a fallback to show the UI structure
//             setProducts(fallbackMockProducts);
//             setCategories(fallbackMockCategories);
//             setActiveTab(fallbackMockCategories[0].name);
            
//         } finally {
//             setIsLoading(false);
//         }
//     }, [authToken]);

//     // Effect to trigger data fetching on mount
//     useEffect(() => {
//         fetchProducts();
//     }, [fetchProducts]);
    
//     // --- Render Logic for Content ---
//     const renderContent = () => {
//         if (isLoading) {
//             return (
//                 <div className="flex flex-col items-center justify-center p-8 text-gray-500">
//                     <Loader2 className="w-8 h-8 animate-spin text-blue-600 mb-3" />
//                     <p className="text-sm font-medium">Loading products...</p>
//                     <p className="text-xs text-center mt-1">Fetching data from remote server...</p>
//                 </div>
//             );
//         }

//         if (error) {
//             return (
//                 <div className="bg-red-50 border-l-4 border-red-500 text-red-700 p-4 mx-4 my-4 rounded-lg shadow-inner">
//                     <div className="flex items-center">
//                         <AlertTriangle className="w-5 h-5 mr-3" />
//                         <p className="font-bold">Data Fetch Error</p>
//                     </div>
//                     <p className="text-sm mt-1">{error}</p>
//                     <p className="text-xs mt-2 italic">Displaying **fallback** product and category data.</p>
//                 </div>
//             );
//         }

//         if (products.length === 0) {
//             return (
//                 <div className="text-center p-8 text-gray-500">
//                     <Zap className="w-8 h-8 mx-auto mb-3" />
//                     <p className="text-sm font-medium">No products found for **{activeTab}**.</p>
//                 </div>
//             );
//         }

//         return (
//             <div className="grid grid-cols-2 gap-3">
//                 {products.map(product => (
//                     <ProductCard 
//                         key={product.id} 
//                         product={product} 
//                         setActiveScreen={setActiveScreen}
//                     />
//                 ))}
//             </div>
//         );
//     };


//     return (
//         <div className="min-h-screen flex justify-center bg-gray-100 font-sans">
//             <style>{`.hide-scrollbar::-webkit-scrollbar { display: none; } .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }`}</style>

//             <div className="w-full max-w-md bg-white shadow-2xl overflow-hidden flex flex-col h-screen">
                
//                 {/* Fixed Top Area (Title and Back button) */}
//                 <header className="px-4 py-3 flex items-center justify-center bg-white sticky top-0 z-20">
//                     {/* Placeholder for back button and battery/time icons */}
//                     <div className="absolute left-4 top-4">
//                         <ChevronLeft className="w-6 h-6 text-gray-800" />
//                     </div>
//                     <h1 className="text-lg font-bold text-gray-800">Marketplace</h1>
//                 </header>

//                 {/* Floating "Marketplace" text and Filter icon */}
//                 <div className="px-4 pb-3 pt-1 flex items-center justify-between bg-white sticky top-[56px] z-10 border-b border-gray-100">
//                     <h2 className="text-xl font-bold text-gray-900">Marketplace</h2>
//                     <button 
//                         className="p-2 text-gray-600 hover:bg-gray-100 rounded-lg transition duration-150"
//                         aria-label="Filter products"
//                         onClick={() => console.log('Filters opened')}
//                     >
//                         <Filter className="w-6 h-6" />
//                     </button>
//                 </div>


//                 {/* Category Tabs (Horizontal Scrollable) */}
//                 <div className="px-4 pb-3 bg-white sticky top-[110px] z-10">
//                     <div className="overflow-x-auto flex space-x-2 hide-scrollbar">
//                         {/* UPDATED: Iterate over the fetched categories array */}
//                         {categories.map(category => (
//                             <button
//                                 key={category.id} // Use category ID as key
//                                 className={`px-4 py-2 text-sm font-semibold rounded-full transition duration-200 whitespace-nowrap ${
//                                     activeTab === category.name
//                                         ? 'bg-blue-600 text-white shadow-md'
//                                         : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
//                                 }`}
//                                 onClick={() => {setActiveTab(category.name); showProducts(category.id)}}
//                             >
//                                 {category.name}
//                             </button>
//                         ))}
//                     </div>
//                 </div>

//                 {/* Product Catalog Grid */}
//                 {/* Removed pb-20 since there is no navbar */}
//                 <main className="flex-1 overflow-y-auto p-4"> 
//                     {renderContent()}
//                 </main>
//             </div>
//         </div>
//     );
// };
// --- Main Screen Component ---

const MarketplaceScreen = ({ setActiveScreen, authToken,productId,handleSignOut }) => {
    
    const [categories, setCategories] = useState([]);
    const [activeTabName, setActiveTabName] = useState(''); 
    const [activeCategoryId, setActiveCategoryId] = useState(null); 
    const [products, setProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    
    // API Endpoints
    // const CATEGORIES_API_URL = API_URL; // Assuming API_URL holds the categories endpoint
    const PRODUCT_API_BASE_URL = `${API_BASE_URL}/product-categories`;

    // 1. Function to fetch products for a specific category
    const fetchProductsByCategory = useCallback(async (categoryId) => {
        if (!categoryId) return;

        setIsLoading(true);
        setError(null);
        
        try {
            const URL = `${PRODUCT_API_BASE_URL}/${categoryId}`;
            
            const response = await fetch(URL, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}` 
                },
            });


                   if (response.status === 401) {
                // 🚨 SESSION INVALID
                // forceLogout("You were logged out because your account was used on another device.");
                handleSignOut()
                return;
            }
            if (!response.ok) {
                const errorBody = await response.text();
                throw new Error(`Failed to fetch products. Status: ${response.status}. Detail: ${errorBody.substring(0, 100)}...`);
            }

            const result = await response.json();
            
            // Assuming products are nested under result.data.products
            const fetchedProducts = result?.data?.category.products|| []; 
            
            setProducts(fetchedProducts);

        } catch (err) {
            console.error(`Failed to fetch products for category ${categoryId}:`, err);
            setError(err.message);
            setProducts([]); // Clear products on error
        } finally {
            // Note: We only set loading to false here if the product fetch finishes after category fetch
            // If categories were still loading, this might override that state. We handle loading in fetchCategories.
            // For now, setting it here is safer for sequential loading.
            setIsLoading(false); 
        }
    }, [authToken]);

    // 2. Function to fetch categories and set the initial view
    const fetchCategories = useCallback(async () => {
        setIsLoading(true);
        setError(null);

        const apiCall = async () => {
            const response = await fetch(PRODUCT_API_BASE_URL, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}` 
                },
            });

                   if (response.status === 401) {
                // 🚨 SESSION INVALID
                // forceLogout("You were logged out because your account was used on another device.");
                handleSignOut()
                return;
            }
            if (!response.ok) {
                const errorBody = await response.text();
                throw new Error(`Failed to fetch categories. Status: ${response.status}. Detail: ${errorBody.substring(0, 100)}...`);
            }
            return response.json();
        };

        try {
            const data = await exponentialBackoffFetch(apiCall);
            
            const fetchedCategories = data?.data?.categories || [];
            setCategories(fetchedCategories);
            
            if (fetchedCategories.length > 0) {
                const defaultCategory = fetchedCategories[0];
                setActiveTabName(defaultCategory.name);
                setActiveCategoryId(defaultCategory.id);
                // Immediately fetch products for the default category
                fetchProductsByCategory(defaultCategory.id); 
            } else {
                 setProducts([]);
                 setIsLoading(false); // Stop loading if no categories exist
            }
            
        } catch (err) {
            console.error('Failed to fetch categories:', err);
            setError(err.message);
            setProducts([]);
            setCategories([]);
            setIsLoading(false);
        }
    }, [authToken, fetchProductsByCategory]);

    // Effect to trigger initial category fetch on mount
    useEffect(() => {
        fetchCategories();
    }, [fetchCategories]);
    
    // --- Event Handler for Tab Click ---
    const handleTabClick = (categoryName, categoryId) => {
        if (categoryId === activeCategoryId) return;
        
        setActiveTabName(categoryName);
        setActiveCategoryId(categoryId);
        // Trigger new product fetch when a tab is clicked
        fetchProductsByCategory(categoryId); 
    };
    
    // --- Render Logic for Content ---
    const renderContent = () => {
        if (isLoading) {
            return (
                <div className="flex flex-col items-center justify-center p-8 text-gray-500">
                    <Loader2 className="w-8 h-8 animate-spin text-blue-600 mb-3" />
                    <p className="text-sm font-medium">Loading products...</p>
                    <p className="text-xs text-center mt-1">Fetching data from remote server...</p>
                </div>
            );
        }

        if (error) {
            return (
                <div className="bg-red-50 border-l-4 border-red-500 text-red-700 p-4 mx-4 my-4 rounded-lg shadow-inner">
                    <div className="flex items-center">
                        <AlertTriangle className="w-5 h-5 mr-3" />
                        <p className="font-bold">Data Fetch Error</p>
                    </div>
                    <p className="text-sm mt-1">{error}</p>
                    <p className="text-xs mt-2 italic">Please try refreshing the page.</p>
                </div>
            );
        }

        if (products.length === 0) {
            return (
                <div className="text-center p-8 text-gray-500">
                    <Zap className="w-8 h-8 mx-auto mb-3" />
                    <p className="text-sm font-medium">No products found for **{activeTabName}**.</p>
                </div>
            );
        }

        return (
            <div className="grid grid-cols-2 gap-3">
                {products.map(product => (
                    <ProductCard 
                        key={product.id} 
                        product={product} 
                        setActiveScreen={setActiveScreen}
                    />
                ))}
            </div>
        );
    };

    return (
        <div className="min-h-screen flex justify-center bg-gray-100 font-sans">
            <style>{`.hide-scrollbar::-webkit-scrollbar { display: none; } .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }`}</style>

            <div className="w-full max-w-md bg-white shadow-2xl overflow-hidden flex flex-col h-screen">
                
                {/* Fixed Top Area (Title and Back button) */}
                <header className="px-4 py-3 flex items-center justify-center bg-white sticky top-0 z-20">
                    <div className="absolute left-4 top-4">
                        <ChevronLeft className="w-6 h-6 text-gray-800" onClick={() => setActiveScreen('home')}/>
                    </div>
                    <h1 className="text-lg font-bold text-gray-800">Marketplace</h1>
                </header>

                {/* Floating "Marketplace" text and Filter icon */}
                <div className="px-4 pb-3 pt-1 flex items-center justify-between bg-white sticky top-[56px] z-10 border-b border-gray-100">
                    <h2 className="text-xl font-bold text-gray-900">Marketplace</h2>
                    <button 
                        className="p-2 text-gray-600 hover:bg-gray-100 rounded-lg transition duration-150"
                        aria-label="Filter products"
                        onClick={() => console.log('Filters opened')}
                    >
                        <Filter className="w-6 h-6" />
                    </button>
                </div>


                {/* Category Tabs (Horizontal Scrollable) */}
                <div className="px-4 pb-3 bg-white sticky top-[110px] z-10">
                    <div className="overflow-x-auto flex space-x-2 hide-scrollbar">
                        {categories.map(category => (
                            <button
                                key={category.id} 
                                className={`px-4 py-2 text-sm font-semibold rounded-full transition duration-200 whitespace-nowrap ${
                                    activeTabName === category.name
                                        ? 'bg-blue-600 text-white shadow-md'
                                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                }`}
                                onClick={() => handleTabClick(category.name, category.id)}
                            >
                                {category.name}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Product Catalog Grid */}
                <main className="flex-1 overflow-y-auto p-4"> 
                    {renderContent()}
                </main>
            </div>
        </div>
    );
};

export default MarketplaceScreen;
